<template>
  <div>
    <!-- <custom-table :items="items" :headers="headers" :loading="loading">
      
    </custom-table>-->
    <v-row>
      <v-col md="6" offset-md="6" sm="6" offset-sm="6">
         <v-text-field v-model="search" label="Search Here" class="my-0 py-0"></v-text-field>
      </v-col>
    </v-row>
   
    <v-data-table :items="items" :headers="headers" :loading="loading" :search="search">
      <template v-slot:item.actions="{item}">
        <slot name="actions" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.details="{item}">
        <slot name="details" v-bind:item="item"></slot>
      </template>
    </v-data-table>
  </div>
</template>
<script>
// import CustomTable from "../../../../components/CustomTable";
const API_ENDPOINT = "/api/region";
export default {
  props: {
    showHeader: {
      default: false,
      type: Boolean
    },
    param: {
      type: String,
      default: ""
    }
  },
  components: {
    // CustomTable
  },
  data: () => ({
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Code",
        value: "alphaRegCode",
        sortable: true
      },
      {
        text: "Description",
        value: "alphaRegDesc",
        sortable: true
      },
      {
        text: "Alpha Main Region",
        value: "alphaRegMainRegionDesc",
        sortable: true
      },
      {
        text: "Details",
        value: "details",
        sortable: true
      }
    ],
    loading: false,
    search: "",
    footerProps: {
      rowsPerPageItems: [20, 50]
    }
  }),
  methods: {
    getAll() {
      this.loading = true;
      this.$axios
        .get(`${API_ENDPOINT}?param=${this.param ?? ''}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    //this.getAll();
  },
  mounted() {
    this.getAll();
  }
};
</script>